import { useEffect, useRef } from 'react'

export function useInitialRender() {
  const firstRender = useRef(true)

  useEffect(() => {
    firstRender.current = false
  }, [])

  return firstRender.current
}
